module.exports = __webpack_public_path__ + "img/kefu.93703575.png";